import { AutogenModelInfoPacketHeader, AutogenRowInfoPacketHeader } from "./autogen/AutogenModelInfoPacketHeader";

export class ModelInfoPacketHeader extends AutogenModelInfoPacketHeader<RowInfoPacketHeader> {
	constructor() {
		super(RowInfoPacketHeader);
	}
}

export class RowInfoPacketHeader extends AutogenRowInfoPacketHeader {
}